import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
//import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { WithContext as ReactTags } from 'react-tag-input';

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import DraggableDivImage from "../../DraggableDiv/DraggableDivImage"
//import { List, arrayMove } from "react-movable";;

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	handle_compressed_image_upload,
} from '../../../Utils';
import Hosts from '../../../Hosts';

import { language } from './Language';
//import { el } from 'date-fns/locale';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [/*date_creation*/, set_date_creation] = useState('') 
	const [/*date_modification*/, set_date_modification] = useState('') 
	const [/*date_publication*/, set_date_publication] = useState('') 
	const [/*date_avaiable*/, set_date_avaiable] = useState('') 

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());


	const [/*isSlug*/, setSlug] = useState(false);

	const [isCombination, setIsCombination] = useState(false);
	const [combinations, setCombinations] = useState([]);
	const [final_combinations, setFinalCombinations] = useState([]);

	const [menus_avaiable, /*set_menus_avaiable*/] = useState([])
	const [brands, set_brands] = useState([])
	const [features, set_features] = useState([])
	const [feature_values, set_feature_values] = useState([])
	const [attributes, set_attributes] = useState([])
	const [attribute_values, set_attribute_values] = useState([])
	const [taxe_values, set_taxe_values] = useState([])
	const [carrier, set_carrier] = useState([])

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);
	//const [save_label, set_save_label] = useState('Salvar');
	//const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)
	const [/*editorLoaded*/, setEditorLoaded] = useState(false);
	
	const [/*selectedFile*/, setSelectedFile] = useState(null);

	const [treeData, setTreeData] = useState([]) 
	const [tags, setTags] = useState([]) 	

	const [suggestions, set_suggestions] = useState([])
	const [keycodes, /*set_keycodes*/] = useState({comma: 188, enter: 13 })
    const [delimiters, /*set_delimiters*/] = useState([keycodes.comma, keycodes.enter])

	const [refresh, setRefresh] = useState(0);

	const [dragId, setDragId] = useState();

	const [files_image, set_files_image] = useState([]);
	const [youtube_link, set_youtube_link] = useState('');
	const [image_base64, set_image_base64] = useState([]);

	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);

	const handleDrag = (ev) => {
	  	setDragId(ev.currentTarget.id);
	};

	const handleDragOver = (ev) => {
		const { dataset } = ev.target;
		const { order } = dataset

		if(order === undefined)
			return 

		let divs = dados.current.content[order].media.image
	
		const dragDiv = divs.find((div) => div.id + '' === dragId + '');
		const dropDiv = divs.find((div) => div.id + '' === ev.currentTarget.id + '');

		if(dragDiv !== undefined && dropDiv !== undefined) {
			const dragDivOrder = dragDiv.order;
			const dropDivOrder = dropDiv.order;

			let aux = []
			divs.forEach((div) => {
				if (div.id + '' === dragId + '') {
					div.order = dropDivOrder;
				}
				if (div.id + '' === ev.currentTarget.id + '') {
					div.order = dragDivOrder;
				}
				aux[div.order] = div
			});
			set_dados(dados.current.content[order].media.image = aux)
		}
	};

	const handleDrop = (ev) => {
		//console.log('drop', ev)
	}

	const handleEdit = (order, id) => {
		set_dados(dados.current.content[order].media)
	};

	const handleRemove = (order, langid, id, link) => {

		// Swal.fire({
		// 	title: language[lang].delete_title,
		// 	text: language[lang].delete_text,
		// 	icon: 'question',
		// 	showCancelButton: true,
		// 	confirmButtonColor: '#0095e8',
		// 	cancelButtonColor: '#d9214e',
		// 	confirmButtonText: language[lang].delete_confirm,
		// 	cancelButtonText: language[lang].delete_cancel
		// })
		// 	.then((result) => {
		// 		if (result.isConfirmed) {

					if (langid === '1') {
						let aux = dados.current.content[order].media.image.filter(v => v.link !== link)
						set_dados(dados.current.content[order].media.image = aux)
					}
					else {
						let aux = dados.current.content[order].language[langid].media.image.filter(v => v.link !== link)
						set_dados(dados.current.content[order].language[langid].media.image = aux)
					}

			// 	}
		// 	})

	};

	const handleChangeContentMediaImage = (e) => {
		const { value, name, dataset } = e.target;
		const { order, id } = dataset

		dados.current.content[order].media.image.forEach(el => {
			if(el.id === id)
				el[name] = value
		})
		set_dados(dados.current.content[order].media.image)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}
	
	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				if(res.data[0].info['media'] !== undefined)
					setSelectedFile(res.data[0].info.media)

				let aux = []
				res.data[0].content.forEach((el, k) => {
					if(el.media !== undefined) {
						aux[k] = []
						aux[k][1] = el.media
					}

					if(el['language'] !== undefined && el['language'].length > 0) {
						el['language'].forEach((el_2) => {
							if(el_2 !== undefined && el_2 !== null) {
								if(el_2['media'] !== undefined && el_2['media'] !== null)
									aux[k][el_2.id] = [{image: [], doc: []}]
		
								if(el_2.media !== undefined)
									aux[k][el_2.id] = el_2.media
							}
						})
					}
				})

				//setSelectedFiles(aux)

				let aux_doc = []
				let i = 0
				aux.forEach((el, k) => {
					el.forEach((el_2, k_2) => {
						el_2.doc.forEach((el_3) => {
							if(aux_doc[k] === undefined)
								aux_doc[k] = []
							if(aux_doc[k][k_2] === undefined)
								aux_doc[k][k_2] = []
								
							aux_doc[k][k_2].push({ id: ++i, id_doc: el_3.id, title: el_3.name, link: el_3.link, visible: el_3.visible})
						})
					})
				})
				setTreeData(aux_doc)
				//console.log(res.data[0])
			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	const is_parent = (id, parent) => {
		let aux = menus_avaiable.filter(v => v.id === id)
		if(aux.length > 0) {
			if(aux[0].info.parent === parent)
				return true
			else {
				return is_parent(aux[0].info.parent, parent)
			}
		}
		else {
			return false
		}
    }

	/*const order_menu = (parent, array, array2) => {
        let array_aux = array.filter(v => v.info.parent === parent)
        array_aux.forEach(v => {
            array2.push(v)
            order_menu(v.id, array, array2)
		})
	}*/
	
	/*const get_parent_depth = (parent, prefix) => {
        let aux = menus_avaiable.filter(v => v.id === parent)
        if(aux.length > 0) {
            prefix += '-'
            return get_parent_depth(aux[0].info.parent, prefix)
        }
        else {
            return prefix
        }
    }*/

	const get_brands = async () => {
		return await reqGET(`${api_crud_base}/store/brand/product/${getTokenInfo().companycode}`)
			.then(res => {
				set_brands(res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const get_features = async () => {
		return await reqGET(`${api_crud_base}/store/feature/product/${getTokenInfo().companycode}`)
			.then(res => {
				set_features(res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const get_feature_values = async (parent_id) => {
		return await reqGET(`${api_crud_base}/store/feature/value/product/parent/${getTokenInfo().companycode}/${parent_id}`)
			.then(res => {
				set_feature_values(res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}


	const get_taxe_values = async () => {
		return await reqGET(`${api_crud_base}/store/taxes/shipping/${getTokenInfo().companycode}`)
			.then(res => {

				let taxe_values_aux = []
				res.data.forEach((el) => {
					taxe_values_aux.push({id: el.id, text: el.info.name, rate: el.info.rate})
				})
				set_taxe_values(taxe_values_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const get_carriers = async () => {
		return await reqGET(`${api_crud_base}/store/carrier/shipping/${getTokenInfo().companycode}`)
			.then(res => {

				let carrier_aux = []
				res.data.forEach((el) => {
					carrier_aux.push({id: el.id, text: el.info.name, rate: el.info.rate})
				})
				set_carrier(carrier_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}


	useEffect(() => {
		//setEditorLoaded(true);
		clean_data();

		set_lang(localStorage.getItem('lang'))


		const get_categories = async () => {
			return await reqGET(`${api_crud_base}/store/category/product/${getTokenInfo().companycode}`)
				.then(res => {
					
					// let suggestions_aux = suggestions
					let suggestions_aux = []
					res.data.forEach((el) => {
						suggestions_aux.push({id: el.id, text: el.info.name, parent: '0'})
	
						get_category_values(el.id, el.info.name)
	
					})
					set_suggestions(suggestions_aux)
	
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	
		const get_category_values = async (parent_id, parent_name) => {
			return await reqGET(`${api_crud_base}/store/category/value/product/parent/${getTokenInfo().companycode}/${parent_id}`)
				.then(res => {
	
					// let suggestions_aux = suggestions
					let suggestions_aux = []
					res.data.forEach((el) => {
						suggestions_aux.push({id: el.id, text: parent_name + ' > ' + el.info.name, parent: parent_id})
					})
					set_suggestions(suggestions_aux)
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	
		const get_attributes = async () => {
			return await reqGET(`${api_crud_base}/store/attribute/product/${getTokenInfo().companycode}`)
				.then(res => {
	
					// let attributes_aux = attributes
					let attributes_aux = []
					res.data.forEach((el) => {
						attributes_aux.push({id: el.id, name: el.info.name, parent: '0'})
	
						get_attribute_values(el.id)
	
					})
					set_attributes(attributes_aux)
	
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	
		const get_attribute_values = async (parent_id) => {
			return await reqGET(`${api_crud_base}/store/attribute/value/product/parent/${getTokenInfo().companycode}/${parent_id}`)
				.then(res => {
	
					// let attributes_aux = attribute_values
					let attributes_aux = []
					res.data.forEach((el) => {
						attributes_aux.push({id: el.id, name: el.info.name, parent: parent_id})
					})
					set_attribute_values(attributes_aux)
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		get_brands()
		get_features()
		get_attributes()

		get_taxe_values()
		get_carriers()

		get_categories()
		//get_categories_values()

		// let aux = [
		// 	{ id: 1, id_doc: 11, title: 'titulo 1.pdf', slug: 'slug 1' },
		// 	{ id: 2, id_doc: 21, title: 'titulo 2.pdf', slug: 'slug 2' },
		// 	{ id: 3, id_doc: 31, title: 'titulo 3.pdf', slug: 'slug 3' },
		// 	{ id: 4, id_doc: 41, title: 'titulo 4.pdf', slug: 'slug 4' }
		// ]
		// setTreeData(aux)

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//console.log('NO EDIT')
				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])
				set_files_doc_name([])

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if(dados.current.info.date.creation !== undefined && dados.current.info.date.creation !== '') {
							let date_creation = new Date(dados.current.info.date.creation); 
							set_date_creation(date_creation.getDate().toString().padStart(2, '0') + '/' + (date_creation.getMonth() + 1).toString().padStart(2, '0') + '/' + date_creation.getFullYear())
						}
						if(dados.current.info.date.published !== undefined && dados.current.info.date.published !== '') {
							let date_publication = new Date(dados.current.info.date.published); 
							set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
						}
						if(dados.current.info.date.avaiable !== undefined && dados.current.info.date.avaiable !== '') {
							let date_avaiable = new Date(dados.current.info.date.avaiable); 
							set_date_avaiable(date_avaiable.getDate().toString().padStart(2, '0') + '/' + (date_avaiable.getMonth() + 1).toString().padStart(2, '0') + '/' + date_avaiable.getFullYear())
						}
						if(dados.current.info.date.modified !== undefined && dados.current.info.date.modified.length > 0) {
							let date_modification = new Date(dados.current.info.date.modified.pop());
							set_date_modification(date_modification.getDate().toString().padStart(2, '0') + '/' + (date_modification.getMonth() + 1).toString().padStart(2, '0') + '/' + date_modification.getFullYear())
						}

						if(dados.current.info['tags'] === undefined) 
							dados.current.info['tags'] = []

						if(dados.current.info.combination.length > 0) {
							setIsCombination(true)
						}

						//console.log(attributes)
						//console.log(attribute_values)

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}


	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					change_item_from_menu('title', dados.current.info.name, dados.current.id)
						.then(() => {
							change_item_from_menu('slug', dados.current.info.slug, dados.current.id)
						})

					files_image.forEach(async (el_image) => {
						if (el_image !== null) {
							if (el_image.files.length > 0) {
								await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
							} else {
								dados.current.content[el_image.order]['media']['image'].push({
									id: '',
									link: el_image.link,
									name: el_image.link,
									description: '',
									type: 'video',
									order: el_image.order,
									lang: []
								})
							}
						}
					})
					set_files_image([])

					files_doc.forEach(async (el_doc) => {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
						}
					})
					set_files_doc([])
					set_files_doc_name([])

					dados.current.info.date.modified.push(today_submit)
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit

					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/store/product/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									console.log(res.data)
									dados.current.id = res.data[0].id

									files_image.forEach(async (el_image) => {
										if (el_image !== null) {
											if (el_image.files.length > 0) {
												await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
											} else {
												dados.current.content[el_image.order]['media']['image'].push({
													id: '',
													link: el_image.link,
													name: el_image.link,
													description: '',
													type: 'video',
													order: el_image.order,
													lang: []
												})
											}
										}
									})
									set_files_image([])

									files_doc.forEach(async (el_doc) => {
										if (el_doc !== null) {
											await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
										}
									})
									set_files_doc([])
									set_files_doc_name([])

									set_is_edit(true)
									set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	const remove_menu_childs = (menu, id) => {

		let menu2 = menu.filter(v => v.id_content !== id)
		if(menu2 !== undefined && menu2.length > 0) {
			menu2.forEach((value) => {
				if(value.children !== undefined && value['children'].length > 0) {
					let menu3 = value.children.filter(v => v.id_content !== id)
					if(menu3 !== undefined && menu3.length > 0) {
						return remove_menu_childs(menu3, id)
					}
					else {
						value.children = []
						return value.children
					}
				}
				else {
					return menu2
				} 
			})
		}
		else {
			return menu
		}


	}

	const remove_content_from_menu = async (id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((value) => {
					if(value.content !== undefined && value.content['childs'].length > 0) {

						value.content.childs = value.content.childs.filter(v => v.id_content !== id)
						remove_menu_childs(value.content.childs, id)

						reqPUT(`${api_crud_base}/web/structure`, value)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const change_item_menu_childs = (menu, name, value, id) => {

		if(menu !== undefined && menu.length > 0) {
			menu.forEach((v) => {

				if(v.id_content === id) {
					v[name] = value
				}

				if(v.children !== undefined && v['children'].length > 0) {
					return change_item_menu_childs(v.children, name, value, id)
				}
				else {
					return menu
				} 
			})
		}
		else {
			return menu
		}
	}

	const change_item_from_menu = async (name, value, id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((v) => {
					if(v.content !== undefined && v.content['childs'].length > 0) {

						//console.log(v);
						change_item_menu_childs(v.content.childs, name, value, id)

						reqPUT(`${api_crud_base}/web/structure`, v)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_base = (e) => {
		const { name, value } = e.target;

		if(dados.current.info['base'] === undefined)
			dados.current.info['base'] = {base: '', taxe: ''}

		set_dados(dados.current.info.base[name] = value)
	}

	const handle_change_info_slug = async (e) => {
		const { name, value } = e.target;

		if(value !== '') {

			let v = value
			get_slug(v, 0)
				.then((res) => {
					if(res) {
						get_slug(v, 1)
							.then((res_2) => {
								set_dados(dados.current.info[name] = res_2)
								e.target.value = res_2

								// setRefresh(refresh + 1)
								// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
								// console.log('Dados Current:' + JSON.stringify(dados))
							})
					}
					else {
						set_dados(dados.current.info[name] = v)

						// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
						// console.log('Dados Current:' + JSON.stringify(dados))
					}
				})
		}
		else {
			set_dados(dados.current.info[name] = '')

			// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
			// console.log('Dados Current:' + JSON.stringify(dados))
		}
	}

	/*const handle_change_info_date = (e) => {
		const { name, value } = e.target;
		
		set_dados(dados.current.info.date[name] = value)

		if(name === 'published') {
			let date_publication = new Date(value); 
			set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
		}
		if(name === 'avaiable') {
			let date_avaiable = new Date(value); 
			set_date_avaiable(date_avaiable.getDate().toString().padStart(2, '0') + '/' + (date_avaiable.getMonth() + 1).toString().padStart(2, '0') + '/' + date_avaiable.getFullYear())
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}*/
	
	const handle_change_content = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)

			if(name === 'title' && order === '0') {
				set_dados(dados.current.info.name = value)
				set_dados(dados.current.info.seo.title = value)
			}
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', description: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_features = (e) => {
		const { value } = e.target;

		set_feature_values([]);
		features.forEach((v) => {
			if(v.id === value) {
				// filter => if exists do nothing else push json
				dados.current.info.features.push({id: v.id, name: v.info.name, values: []})
				get_feature_values(v.id)
			}
		})
	}

	const handle_change_info_features_value = (e) => {
		const { value } = e.target;

		feature_values.forEach((v) => {
			if(v.id === value) {
				dados.current.info.features.forEach((vF) => {
					if(vF.id === v.info.feature) {
						let x = vF.values.filter(vF_aux => vF_aux.id === v.id)

						if(x.length === 0) {
							vF.values.push({id: v.id, name: v.info.name})

							setRefresh(refresh + 1)
						}
					}
				})
			}
		})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_remove_info_features_value = (feature, value) => {

		dados.current.info.features.forEach((v) => {
			if(v.id === feature) {
				v.values = v.values.filter(el => el.id !== value)

				set_dados(dados.current.info.features, )

				// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
				// console.log('Dados Current:' + JSON.stringify(dados))

				setRefresh(refresh + 1)
			}
		})

	}

	const handle_change_info_brands = (e) => {
		const { value } = e.target;

		dados.current.info.brands = []
		brands.forEach((v) => {
			if(v.id === value) {
				dados.current.info.brands.push({id: v.id, name: v.info.name})
			}
		})

	}

	const handle_change_info_quantity = (e) => {
		const { name, value } = e.target;

		if(dados.current.info['quantity'] === undefined) {
			dados.current.info['quantity']= [];
			dados.current.info['quantity'].push(data_interface.info['quantity'][0]);
		}

		set_dados(dados.current.info['quantity'][0][name] = value)
		//console.log(dados.current.info['quantity'])
	}

	const handleSingleCheckStock = e => {
		const { name } = e.target;

		if(dados.current.info['quantity'] === undefined) {
			dados.current.info['quantity'] = [];
			dados.current.info['quantity'].push(data_interface.info['quantity'][0]);
		}

		set_dados(dados.current.info.quantity[0][name] = !dados.current.info.quantity[0][name])
	}

	const change_is_combination = () => {

		const tmp_data = JSON.parse(JSON.stringify(data_interface.info.quantity))

		if(isCombination === true) {
			dados.current.info.combination = []
			dados.current.info.quantity.push(tmp_data[0])

			setIsCombination(!isCombination)
		}
		else {
			tmp_data[0]['combination'] = ''

			dados.current.info.quantity = []
			dados.current.info.combination.push(tmp_data[0])

			setIsCombination(!isCombination)
		}
	} 

	const handleCheckCombination = e => {
		const { value, dataset } = e.target;
		const { parent } = dataset;

		let aux = combinations
		if(aux[parent] === undefined)
			aux[parent] = []

		let aux2 = aux[parent].filter(v => v === value)
		if(aux2.length === 0) {
			aux[parent].push(value)
		}
		else {
			aux[parent] = aux[parent].filter(v => v !== value)

			if(aux[parent].length === 0) {
				aux[parent] = undefined
			}
		}

		setCombinations(aux)
	}

	const generateCombination = () => {

		let lista_aux = combinations //.filter(v => v !== undefined)
		let lista_final = combina(lista_aux)
		//console.log('lista_final', lista_final)

		let lista_combinacoes = []
		lista_final[0].forEach((el, k) => {
			el.forEach((el_2) => {
				//console.log('el_2', el_2)

				if(lista_combinacoes[k] === undefined)
					lista_combinacoes[k] = []

				lista_combinacoes[k].push(el_2)
			})
		})
		
		console.log(lista_combinacoes)
		setFinalCombinations(lista_combinacoes)
	}

	let combina = (lista_arrays) => {

		if(lista_arrays.length === 1) {
			// console.log('resultado:', lista_arrays)
			return lista_arrays
		}
		
		var first, second, rest;
		[first, second, ...rest] = lista_arrays

		// console.log('first:', first)
		// console.log('second:', second)
		// console.log('rest:', rest)

		if(first === undefined)
			first = ['0']

		if(second === undefined)
			second = ['0']

		let tmp = first.flatMap(d => second.map(v =>  d.length > 0 ? [...d, v] :  [d, v]))
		// console.log('flatMap:', tmp)
	
		rest = rest.reverse()
		let new_lista = [...rest, tmp].reverse()
		//let new_lista = [...tmp, rest] //.reverse()
		//console.log('new_lista:', new_lista)
		return combina(new_lista)

	} 

	const handleSelectCombination = e => {
		const { /*name, value,*/ dataset } = e.target;
		const { combination } = dataset;

		const tmp_data = JSON.parse(JSON.stringify(data_interface.info.quantity))
		tmp_data[0]['combination'] = combination

		// { 
		// 	combination: combination,
		// 	units: '',
        //     minimum_for_sale: '1',
        //     stock: '',
        //     low_stock_warning: '',
        //     low_stock_email_warning: false,
        //     stock_out: 'deny', 
        //     label_in_stock: '',
        //     label_out_stock: ''
		// };

		if(dados.current.info.combination === undefined)
			dados.current.info.combination = []

		let tmp = dados.current.info.combination.filter(k => k.combination === tmp_data[0].combination)

		console.log('tmp', tmp)

		if(tmp.length === 0) {
			dados.current.info.quantity = []

			console.log('tmp_data[0]', tmp_data[0])

			dados.current.info.combination.push(tmp_data[0])
		}
		else { //Vai Retirar
			dados.current.info.quantity = []
			dados.current.info.combination = dados.current.info.combination.filter(k => k.combination !== tmp_data[0].combination)
		}

		if(dados.current.info.combination.length === 0) {
			dados.current.info.quantity = JSON.parse(JSON.stringify(data_interface.info.quantity))
		}

		/* //console.log('dados.current.credits')
		//console.log(dados.current.credits) */
		set_dados(dados.current.info.combination, )

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados.current.info.combination))
	}

	const handle_change_info_quantity_stock_out = e => {
		const { name, value } = e.target;

		if(dados.current.info['quantity'] === undefined) {
			dados.current.info['quantity']= [];
			dados.current.info['quantity'].push(data_interface.info['quantity'][0]);
		}

		set_dados(dados.current.info.quantity[0][name] = value)
	}

	const handle_change_combination = e => {
		const { name, value, dataset } = e.target;
		const { order, combination } = dataset;

		console.log('n', name)
		console.log('v', value)
		console.log('o', order)
		console.log('c', combination)

		if(dados.current.info.combination[order][name] === undefined)
			dados.current.info.combination[order][name] = ''

		//dados.current.info.combination[order][name] = value

		set_dados(dados.current.info.combination[order][name] = value)
		console.log('data', dados.current.info.combination)
	}

	const remove_combination = (combination) => {

		let results = dados.current.info.combination.filter(element => {
			return element.combination !== combination;
		});
		

		results = results.filter(element => {
			return element !== null;
		});

		set_dados(dados.current.info.combination = results)
	}

	const set_combination_image = (order, link) => {

		if(dados.current.info.combination[order]['image'] === undefined)
			dados.current.info.combination[order]['image'] = ''

		set_dados(dados.current.info.combination[order]['image'] = link)
		console.log('data', dados.current.info.combination)
	}

	const get_value_content_lang = (order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				return dados.current.content[order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	/*const handle_change_image_name = (e) => {
		const { value, dataset } = e.target;
		const { order, id } = dataset

		dados.current.content[order].media.image.forEach((el) => {
			if(el.id === id)
				el.name = value
		})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const remove_content_image = (order, id) => {
		let aux = []
		dados.current.content[order].media.image.forEach((el) => {
			if(el.id !== id)
				aux.push(el)
		})
		set_dados(dados.current.content[order].media.image = aux)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	const handle_change_info_seo = (e) => {
		const { name, value } = e.target;

		if(!dados.current.info.seo)
			dados.current.info.seo = {}

		set_dados(dados.current.info.seo[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	/*function slugify_2(str) {
		return str.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
	}*/

	const get_slug = async (slug, i) => {
		if(i === 0) {
			return await reqGET(`${api_crud_base}/store/product/slug/${getTokenInfo().companycode}/${slug}`)
				.then(res => {
					if(res.data.length > 0) {
						setSlug(true)
						return true
					}
					else {
						setSlug(false)
						return false
					}
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
		else {
			return await reqGET(`${api_crud_base}/store/product/slug/${getTokenInfo().companycode}/${slug}-${i}`)
			.then(res => {
				if(res.data.length > 0) {
					//setSlug(true)
					return get_slug(slug, i + 1)
				}
				else {
					setSlug(false)
					return slug + '-' + i
				}
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	}

	/*function slugify(str, n) {
		str = str.replace(/^\s+|\s+$/g, ''); // trim
		str = str.toLowerCase();
	
		// remove accents, swap ñ for n, etc
		var from = "ãàáäâáº½èéëêìíïîõòóöôùúüûñç·/_,:;";
		var to   = "aaaaaeeeeeiiiiooooouuuunc------";
		for (var i=0, l=from.length ; i<l ; i++) {
			 str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
		}
	
		str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
			.replace(/\s+/g, '-') // collapse whitespace and replace by -
			.replace(/-+/g, '-'); // collapse dashes

		return str;
	};*/

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		if (langid === '1') {
			if (dados.current.content[order]['media'] === undefined)
				dados.current.content[order]['media'] = { image: [], doc: [] }
		}
		else {
			if (dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if (dados.current.content[order]['language'][langid] === undefined)
				dados.current.content[order]['language'][langid] = []

			if (dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = { image: [], doc: [] }

			if (dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = { image: [], doc: [] }
		}

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v, k) => {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(v);
				let files_img_aux = image_base64

				if (files_img_aux[order] === undefined)
					files_img_aux[order] = []
				if (files_img_aux[order][langid] === undefined)
					files_img_aux[order][langid] = []

				files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })

				set_image_base64(files_img_aux)

				console.log('image_base64', image_base64)
				if (filesArray.length === (k + 1)) {
					set_dados(dados.current,)
					setRefresh(refresh + 1)
				}
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const save_content_media_youtube_change = (type, order, langid) => {

		if (langid === '1') {
			if (dados.current.content[order]['media'] === undefined)
				dados.current.content[order]['media'] = { image: [], doc: [] }
		}
		else {
			if (dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if (dados.current.content[order]['language'][langid] === undefined)
				dados.current.content[order]['language'][langid] = []

			if (dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = { image: [], doc: [] }

			if (dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = { image: [], doc: [] }
		}

		console.log('media', dados.current.content[order]['media']['image'])

		let files_img_aux = image_base64

		if (files_img_aux[order] === undefined)
			files_img_aux[order] = []
		if (files_img_aux[order][langid] === undefined)
			files_img_aux[order][langid] = []

		files_img_aux[order][langid].push({ id: '1', langid: langid, name: youtube_link, link: youtube_link })
		set_image_base64(files_img_aux)

		let files_aux = files_image
		files_aux.push({ files: [], link: youtube_link, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

		set_youtube_link('')
		setRefresh(refresh + 1)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_name(aux2)

				let aux_doc = treeData
				if (treeData[order] === undefined)
					treeData[order] = []
				if (treeData[order][langid] === undefined)
					treeData[order][langid] = []
				let i = treeData[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeData(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc(files_aux)
	}

	const uploadFilesDoc = (files, order, type, langid, lang) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'store')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (langid === '1') {
					if (type === 'image') {
						dados.current.content[order]['media'][type].push({
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
					if (type === 'doc') {
						dados.current.content[order]['media'][type].push({
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}
				else {
					if (type === 'image') {
						dados.current.content[order]['language'][langid]['media'][type].push({
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
					if (type === 'doc') {
						dados.current.content[order]['language'][langid]['media'][type].push({
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	/*const add_content = () => {
		
		dados.current.content.push(data_interface.content[0])
		set_dados(dados.current.content)
		setEditorLoaded(false);
		setRefresh(refresh + 1)

		setTimeout(
            function() { 
				setEditorLoaded(true);
            }
        , 1000);

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	const handle_change_tree = (tD, order, langid) => {

		treeData[order][langid] = tD

		let aux = []
		if(langid === '1') {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeData(treeData)
		}
		else {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeData(treeData)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				let treeAux = treeData[order][langid].filter(v => v.id !== id)
				treeData[order][langid] = treeAux
				setTreeData(treeData)

				let aux = []
				if(langid === '1') {
					dados.current.content[order].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order].media.doc = aux)
				}
				else {
					dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
				}

			}
		})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, id, doc } = dataset

		treeData[order].forEach((el) => {
			if(el.id === id) {
				el.title = value

				dados.current.content[order].media.doc.forEach((el_2) => {
					if(el_2.id === doc)
						el_2.name = value
				})
			}
		})
		setTreeData(treeData)
	}

	const handleTagDelete = i => {
		let tags = dados.current.info['tags'].filter((tag, index) => index !== i)

		set_dados(dados.current.info['tags'] = tags)
	};
	
	const handleTagAddition = tag => {

		if(tag.parent !== undefined) {
			dados.current.info.category[0] = {id: tag.id, text: tag.text, parent: tag.parent}
		}

	};

	const handleTagDrag = (tag, currPos, newPos) => {
		const newTags = tags.slice();

		newTags.splice(currPos, 1);
		newTags.splice(newPos, 0, tag);

		// re-render
		setTags(newTags);
	};

	const handleTagClick = index => {
		//console.log('The tag at index ' + index + ' was clicked');
	};

	const handleSelectCarrier = e => {
		const { dataset } = e.target;
		const { id, /*order*/ } = dataset

		if(dados.current.info['shipping'] === undefined) {
			dados.current.info['shipping'] = {
				width: '0',
				height: '0',
				depth: '0',
				weight: '0',
				carrier: []
			}
		}

		if(dados.current.info.shipping['carrier'].length === 0) {
			dados.current.info.shipping['carrier'] = [{
				id: id,
				state: true
			}]
		}
		else {
			let tmp = dados.current.info.shipping.carrier.filter(k => k.id === id)
			if(tmp.length === 0) {
				dados.current.info.shipping.carrier.push({
					id: id,
					state: true
				})
			}
			else {
				dados.current.info.shipping.carrier.forEach((el) => {
					if(el.id === id) {
						el.state = !el.state
					}
				})
			}
		}

		set_dados(dados.current.info['shipping'], )

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info.shipping))
	}

	const handleCarrierCheckVerify = (id) => {
		let result = false
		if(dados.current.info['shipping'] !== undefined && dados.current.info.shipping['carrier'] !== undefined) {
			dados.current.info.shipping.carrier.forEach((el) => {	
				if(el.id === id) {
					result = true
				}
			})
		}
		return result
	}

	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].content}</h2>
					<p>{language[lang].content} / {dados.current.id !== '' ? language[lang].content_edit : language[lang].content_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="col-md-8 mb-3 mb-xl-10">

								<div className="tab-content" id="tabContent">
									<div className="card mb-3">
										<div className="card-header border-0">
											<ul className="nav nav-tabs nav-line-tabs border-bottom-0 mt-2 mb-1 fs-6">
												<li className="nav-item mb-1 me-1">
													<a className={"btn btn-sm btn-secondary rounded-0 active"} data-bs-toggle="tab" href={"#tab_pane_geral"}>{language[lang].tab_geral}</a>
												</li>

												<li className={"nav-item mb-1 me-1" + (isCombination ? ' d-none' : '')}>
													<a className={"btn btn-sm btn-secondary rounded-0"} data-bs-toggle="tab" href={"#tab_pane_qtd"}>{language[lang].tab_qtd}</a>
												</li>

												<li className={"nav-item mb-1 me-1" + (isCombination ? '' : ' d-none')}>
													<a className={"btn btn-sm btn-secondary rounded-0"} data-bs-toggle="tab" onClick={() => setRefresh(refresh + 1)} href={"#tab_pane_combinations"}>{language[lang].tab_combinations}</a>
												</li>
												
												<li className="nav-item mb-1 me-1">
													<a className={"btn btn-sm btn-secondary rounded-0"} data-bs-toggle="tab" href={"#tab_pane_shipping"}>{language[lang].tab_shipping}</a>
												</li>
													
											</ul>
										</div>
									</div>

									{
									dados.current.content.map((el, k) => {
										return (
											<div key={k} className={"tab-pane show active"} id={"tab_pane_geral"} role="tabpanel">

												<div className="card">
													<div className="card-header border-0 d-flex justify-content-sm-between">
														<div className="card-title m-0">
															<h3 className="fw-bolder m-0">{language[lang].tab_geral}</h3>
														</div>
														<div className="card-toolbar">
															<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<li key={k_lang} className="nav-item">
																				<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																			</li>
																		)
																	})
																:
																	''
																}
															</ul>
														</div>
													</div>
													<div id="div-content" >
														<div className="card-body border-top p-4">
															<div className="tab-content" id={"tabContentLang_" + k} >
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_content_" + k +  "_language_" + k_lang} role="tabpanel">

																				<div className="row mb-3">
																					<div className="col-12">
																						<label className={k === 0 && el_lang.id === '1' ? "col-form-label required fw-bold fs-6" : "col-form-label fw-bold fs-6"}>{language[lang].title} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="text" name="title" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.title : get_value_content_lang(k, el_lang.id, 'title') } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].title_placeholder} onChange={handle_change_content} required={k === 0 && el_lang.id === '1' ? 'required' : ''} />
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<div className="div-image">
																							<label className="col-form-label fw-bold fs-6">{language[lang].images}</label>

																							<div className="dropzone-panel mb-2">
																								<div className="div-form-input col-12 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-content-" + k + "-" + el_lang.id}>{language[lang].image_choose}</label>
																									<input
																										id={"input-files-content-" + k + "-" + el_lang.id}
																										type="file"
																										accept="image/*"
																										data-order={k}
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										data-type={'image'}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																										onChange={onChangeHandlerFilesImage}
																										multiple
																									/>

																									<button type="button" className="btn btn-sm btn-secondary rounded-0 me-2" data-bs-toggle="modal" data-bs-target={"#modal_media_youtube_bloco_" + k}>
																										{language[lang].youtube_choose}
																									</button>

																									<div className="modal bg-light fade" tabIndex="-1" id={"modal_media_youtube_bloco_" + k}>
																										<div className="modal-dialog modal-dialog-centered">
																											<div className="modal-content shadow-none">
																												<div className="modal-header">
																													<h5 className="modal-title">{language[lang].multimedia}</h5>

																													<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
																														<i className="bi bi-x fs-2"></i>
																													</div>
																												</div>

																												<div className="modal-body">
																													<div className="pb-10">
																														<div className="div-table">
																															<div className="table-body">

																																<div className="fw-bold mb-3">
																																	<span className="fs-6 fw-bolder text-gray-900">
																																		<input type="text" name="youtube_link" value={youtube_link} className="form-control form-control-lg rounded-0 mb-3 mb-lg-0" placeholder={language[lang].youtube_placeholder} onChange={(e) => set_youtube_link(e.target.value)} />
																																	</span>
																																</div>

																																{
																																	// https://www.youtube.com/watch?v=JrdEMERq8MA
																																	youtube_link !== '' ?
																																		<>
																																			<img className='img-fluid' src={'https://img.youtube.com/vi/' + youtube_link.split('watch?v=')[1] + '/0.jpg'} e="https://www.youtube.com/embed/JrdEMERq8MA" alt="YouTube video player" title="YouTube video player" />
																																			{/*<!--iframe width="100%" height="315" src={youtube_link.replace('watch?v=', 'embed/')} e="https://www.youtube.com/embed/JrdEMERq8MA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>*/}
																																		</>
																																		:
																																		''
																																}
																															</div>
																														</div>
																													</div>
																												</div>

																												<div className="modal-footer">
																													<button type="button" className="btn btn-light" data-bs-dismiss="modal">{language[lang].close}</button>
																													<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => save_content_media_youtube_change('image', k, el_lang.id)}>{language[lang].save}</button>
																												</div>
																											</div>
																										</div>
																									</div>
																								</div>
																							</div>

																							<div className="row">
																								{
																								el_lang.id === '1' && el['media'] !== undefined && el['media']['image'] !== undefined ?
																									<>
																										{
																										el['media']['image']
																											.sort((a, b) => a.order - b.order)
																											.map((el_media, k_media) => {
																												el_media.order = k_media

																												return (
																													<DraggableDivImage 
																														key={k_media}
																														divNumber={k_media}
																														idImage={el_media.id}
																														linkImage={el_media.link}
																														nameImage={el_media.name}
																														urlImage={el_media.url}
																														descImage={el_media['description']}
																														contentOrder={k}
																														language={language}
																														lang={lang}

																														data-order={k}
																														data-id={k_media}

																														handleDrag={handleDrag}
																														handleDragOver={handleDragOver}
																														handleDrop={handleDrop}
																														handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																														handleEdit={(e) => handleEdit(k, el_media.id)}
																														handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																													/>
																												)
																										}) 
																										}

																										{
																										image_base64 !== undefined && image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																											image_base64[k][el_lang.id].map((el_media, k_media) => {
																												return (
																													<DraggableDivImage 
																														key={k_media}
																														divNumber={k_media}
																														idImage={el_media.id}
																														linkImage={el_media.link}
																														nameImage={el_media.name}
																														urlImage={el_media.url}
																														descImage={el_media['description']}
																														contentOrder={k}
																														language={language}
																														lang={lang}

																														data-order={k}
																														data-id={k_media}

																														handleDrag={handleDrag}
																														handleDragOver={handleDragOver}
																														handleDrop={handleDrop}
																														handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																														handleEdit={(e) => handleEdit(k, el_media.id)}
																														handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																													/>
																												)
																											}) 
																										:
																											null
																										}
																									</>
																								: 
																									(
																									el['language'] !== undefined && el['language'].length > 0 && el['language'][el_lang.id]['media'] !== undefined && el['language'][el_lang.id]['media']['image'] !== undefined ?
																										<>
																											{
																											el['language'][el_lang.id]['media']['image']
																												.sort((a, b) => a.order - b.order)
																												.map((el_media, k_media) => {
																													el_media.order = k_media

																													return (
																														<DraggableDivImage 
																															key={k_media}
																															divNumber={k_media}
																															idImage={el_media.id}
																															linkImage={el_media.link}
																															nameImage={el_media.name}
																															urlImage={el_media.url}
																															descImage={el_media['description']}
																															contentOrder={k}
																															language={language}
																															lang={lang}

																															data-order={k}
																															data-id={k_media}

																															handleDrag={handleDrag}
																															handleDragOver={handleDragOver}
																															handleDrop={handleDrop}
																															handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																															handleEdit={(e) => handleEdit(k, el_media.id)}
																															handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																														/>
																													)
																											}) 
																											}

																											{
																											image_base64 !== undefined && image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																												image_base64[k][el_lang.id].map((el_media, k_media) => {
																													return (
																														<DraggableDivImage 
																															key={k_media}
																															divNumber={k_media}
																															idImage={el_media.id}
																															linkImage={el_media.link}
																															nameImage={el_media.name}
																															urlImage={el_media.url}
																															descImage={el_media['description']}
																															contentOrder={k}
																															language={language}
																															lang={lang}

																															data-order={k}
																															data-id={k_media}
				
																															handleDrag={handleDrag}
																															handleDragOver={handleDragOver}
																															handleDrop={handleDrop}
																															handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																															handleEdit={(e) => handleEdit(k, el_media.id)}
																															handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																														/>
																													)
																												}) 
																											:
																												null
																											}
																										</>
																									: 
																										''
																									) 
																								}
																							</div>
																						</div>
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6">{language[lang].description}</label>
																						<AssecCKEditor
																							name={"description-" + k}
																							content={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'description')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'description')}
																						/>
																						
																						<textarea className="form-control form-control-lg mb-3 mb-lg-0 d-none" name="description" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.description : get_value_content_lang(k, el_lang.id, 'text') } rows="4" onChange={handle_change_content} />
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6">{language[lang].text}</label>
																						<AssecCKEditor
																							name={"text-" + k}
																							content={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'text')}
																						/>
																						
																						<textarea className="form-control form-control-lg mb-3 mb-lg-0 d-none" name="text" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') } rows="4" onChange={handle_change_content} />
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<div className="div-doc">
																							<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																							<div className="dropzone-panel mb-lg-0 mb-2">
																								<div className="div-form-input col-12 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + k + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																									<input 
																										id={"input-files-pdf-" + k + '-' + el_lang.id}
																										type="file" 
																										accept="application/pdf"
																										data-order={k}
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										data-type={'doc'}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																										onChange={onChangeHandlerFilesPDF}
																										multiple
																									/> 
																								</div>
																							</div>

																							<div className="row">
																								{
																								treeData[k] !== undefined && treeData[k][el_lang.id] !== undefined ?
																									<SortableTree
																										isVirtualized={false}
																										treeData={treeData[k][el_lang.id]}
																										maxDepth={1}
																										//onChange={() => console.log('onChange')}
																										onChange={treeData => handle_change_tree(treeData, k, el_lang.id)}
																										getNodeKey={({ node }) => node.id}
																										generateNodeProps={extendedNode => ({
																											title: (
																												<input type="text" className="form-control form-control-sm" defaultValue={extendedNode.node.title} data-order={k} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} onBlur={edit_element_tree} />
																											),
																											buttons: [
																												<button type="button" onClick={() => console.log('link')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																												<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																												<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																												<button type="button" onClick={() => remove_element_tree(k, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																											],
																										})}
																									/>
																								: 
																									''
																								}
																							</div>
																						</div>
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12 col-sm-6">
																						<label className="col-form-label fw-bold fs-6">{language[lang].field_brand}</label>

																						<select className="form-select rounded-0" aria-label="Select Brand" name='brand' data-order={k} defaultValue={dados.current.info.brands[0] !== undefined ? dados.current.info.brands[0].id : ''} onChange={handle_change_info_brands}>
																							<option value=""></option>
																							{
																							brands.map((v, k) => {
																								return (
																									<option key={k} value={v.id}>{v.info.name}</option>
																								)
																							})
																							}
																						</select>
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12 col-sm-6">
																						<label className="col-form-label fw-bold fs-6">{language[lang].field_features}</label>

																						<select className="form-select rounded-0" aria-label="Select Feature" name='features' data-order={k} defaultValue={''} onChange={handle_change_info_features}>
																							<option value=""></option>
																							{
																							features.map((v, k) => {
																								return (
																									<option key={k} value={v.id}>{v.info.name}</option>
																								)
																							})
																							}
																						</select>
																					</div>

																					<div className="col-12 col-sm-6">
																						<label className="col-form-label fw-bold fs-6">&nbsp;</label>

																						{
																						feature_values.length > 0 ?
																							<select className="form-select rounded-0" aria-label="Select Feature Value" name='feature_value' data-order={k} defaultValue={''} onChange={handle_change_info_features_value}>
																								<option value=""></option>
																								{
																								feature_values.map((v, k) => {
																									return (
																										<option key={k} data-feature={v.info.feature} value={v.id}>{v.info.name}</option>
																									)
																								})
																								}
																							</select>
																						:
																							''
																						}
																					</div>

																					<div className="col-12 col-sm-6">
																						{
																						dados.current.info.features.map((v, k) => {
																							if(v.values.length > 0) {
																								return (
																									v.values.map((vV, kV) => {
																										return (
																											<div key={kV}>
																												<div className="input-group input-group-sm mt-3 p-0">
																													<input type="text" defaultValue={v.name} className="form-control rounded-0 me-2" />
																													<input type="text" defaultValue={vV.name} className="form-control rounded-0 me-2" />
																													<button type="button" className="btn btn-secondary rounded-0" onClick={() => handle_remove_info_features_value(v.id, vV.id)}><i className="bi bi-x"></i></button>
																												</div>
																											</div>
																										)
																									})
																								)
																							}
																							else
																								return ''
																						})
																						}
																					</div>
																				</div>
																				
																			</div>
																		)
																	})
																: 
																	''
																}
															</div>
														</div>
													</div>
												</div>

											</div>
											)
										})
									}

									{
									dados.current.info['quantity'] !== undefined && dados.current.info['quantity'].length > 0 ?
										<div className={"tab-pane show"} id={"tab_pane_qtd"} role="tabpanel">
											<div className="card">
												<div className="card-header border-0 d-flex justify-content-sm-between">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].tab_qtd}</h3>
													</div>
													<div className="card-toolbar">
														
													</div>
												</div>
					
												<div className="card-body border-top p-4">
													<div className="tab-content">

														<div className="row mb-3">
															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_units}</label>
																<input type="text" name="units" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['units'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_units_placeholder} onChange={handle_change_info_quantity} />
															</div>

															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_minimum}</label>
																<input type="text" name="minimum_for_sale" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['minimum_for_sale'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_minimum_placeholder} onChange={handle_change_info_quantity} />
															</div>
														</div>

														<div className="row mb-3  mt-5">
															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_stock}</label>
																<input type="text" name="stock" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['stock'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_stock_placeholder} onChange={handle_change_info_quantity} />
															</div>
														</div>

														<div className="row mb-3">
															<div className="col-8">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_low_stock_warning}</label>
																<input type="text" name="low_stock_warning" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['low_stock_warning'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_low_stock_warning_placeholder} onChange={handle_change_info_quantity} />
															</div>
															<div className="col-md-4">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_low_stock_email_warning}</label>
																<div className="input-group">
																	<label className="switch">
																		<input
																			id={'item-switch'}
																			name={"low_stock_email_warning"}
																			className=""
																			type="checkbox"
																			value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['low_stock_email_warning'] : false }
																			onChange={handleSingleCheckStock}
																			defaultChecked={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['low_stock_email_warning'] : false }
																		/>
																		<span className="slider round" htmlFor={'item-switch'}></span>
																	</label>
																</div>
															</div>
														</div>

														<div className="row mb-3 mt-5">
															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_stock_out}</label>

																<div className="">
																	<input
																		id="radio_0"
																		type="radio"
																		name="stock_out"
																		value="deny"
																		defaultChecked={dados.current.info['quantity'] !== undefined && dados.current.info['quantity'][0]['stock_out'] === 'deny' ? true : false}
																		onChange={handle_change_info_quantity_stock_out} 
																	/>
																	<span className="checkmark"></span>
																	<label className="assec-pl-5" htmlFor="radio_0">{language[lang].field_quantity_stock_out_deny}</label>
																</div>

																<div className="">
																	<input
																		id="radio_1"
																		type="radio"
																		name="stock_out"
																		value="allow"
																		defaultChecked={dados.current.info['quantity'] !== undefined && dados.current.info['quantity'][0]['stock_out'] === 'allow' ? true : false}
																		onChange={handle_change_info_quantity_stock_out} 
																	/>
																	<span className="checkmark"></span>
																	<label className="assec-pl-5" htmlFor="radio_1">{language[lang].field_quantity_stock_out_allow}</label>
																</div>

															</div>
														</div>

														<div className="row mb-3">
															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_label_in_stock}</label>
																<input type="text" name="label_in_stock" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['label_in_stock'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_label_in_stock_placeholder} onChange={handle_change_info_quantity} />
															</div>

															<div className="col-12 col-sm-6">
																<label className="col-form-label fw-bold fs-6">{language[lang].field_quantity_label_out_stock}</label>
																<input type="text" name="label_out_stock" value={dados.current.info['quantity'] !== undefined ? dados.current.info['quantity'][0]['label_out_stock'] : '' } className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_quantity_label_out_stock_placeholder} onChange={handle_change_info_quantity} />
															</div>
														</div>

													</div>
												</div>
											</div>
										</div>
									:
										null
									}

									<div className={"tab-pane show"} id={"tab_pane_combinations"} role="tabpanel">
										<div className="card">
											<div className="card-header border-0 d-flex justify-content-sm-between">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].tab_combinations}</h3>
												</div>
												<div className="card-toolbar">
													
												</div>
											</div>
				
											<div className="card-body border-top p-4">
												<div className="tab-content">

													<div className="accordion" id="accordionCombinations">
														<div className="accordion-item border-0">
															<h2 className="accordion-header border-0" id="headingCombinations">
																<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCombinations" aria-expanded="true" aria-controls="collapseCombinations">
																	Adicionar Combinações
																</button>
															</h2>
															<div id="collapseCombinations" className="accordion-collapse collapse" aria-labelledby="headingCombinations" data-bs-parent="#accordionCombinations">
																<div className="accordion-body">
																	<div className="form-group">
																		<div className="row mb-3">
																			{
																			attributes.map((el, el_key) => {
																				return (
																					<div key={el_key} className="col-6 col-sm-3 mb-3">
																						<label className="col-form-label fw-bold fs-6">{el.name}</label>

																						<span className="div-checkbox-group">
																							{
																							attribute_values.map((el_v, el_v_key) => {
																								if(el_v.parent === el.id) {
																									return (
																										<div key={el_v_key} className="form-check">
																											<input
																												id={"attribute_value_" + el_v.id}
																												name={el_v.name}
																												className="form-check-input"
																												type="checkbox"
																												value={el_v.id}
																												data-parent={el.id}
																												onChange={handleCheckCombination}
																												//defaultChecked={handleSingleCheck_ver(value.id)}
																											/>
																											<label className="form-check-label" htmlFor={"attribute_value_" + el_v.id}>
																												{el_v.name}
																											</label>
																										</div>
																									)
																								} else
																									return ''
																							})
																							}
																						</span>
																					</div>
																				)
																			})
																			}
																		</div>

																		<div className="row">
																			<div className="text-end">
																				<button className="btn btn-sm btn-secondary rounded-0" type="button" onClick={() => generateCombination()}>Gerar Combinaçãoes</button>
																			</div>
																		</div>
																	</div>

																	{
																	final_combinations.length > 0 ?
																		<div className="form-group">
																			<div className="row mb-3 mt-2">

																				<div className="col-12 div-combinations">
																					<table>
																						<thead>
																							<tr>
																								<td></td>
																								<td></td>
																							</tr>
																						</thead>
																						<tbody>
																							{
																							final_combinations.map((el, el_key) => {
																								
																								return (
																									<tr key={el_key}>
																										<td>
																											<input 
																												type="checkbox" 
																												className={"me-3"}
																												name={""}
																												value={""}
																												data-combination={el.join(';')}
																												onChange={handleSelectCombination}
																											/>

																											{dados.current.info.name}
																										</td>
																										<td className='attributes'>
																											{
																											el.map((el_2, el_2_key) => {
																												if(el_2 !== '0') {
																													return (
																														<span key={el_2_key}>
																															{/* attributes.filter(v => v.id === attribute_values.filter(v => v.id === el_2)[0].parent)[0].name */} 
																															{attribute_values.filter(v => v.id === el_2)[0].name}
																														</span>
																													)
																												} 
																												else
																													return ''
																											})
																											}
																										</td>
																									</tr>
																								)
																							})
																							}
																						</tbody>
																					</table>
																				</div>

																			</div>
																		</div>
																	:
																		null
																	}
																</div>
															</div>
														</div>
													</div>

													<div className="form-group">
														<div className="row mb-3 mt-3">

															<div className="col-12 div-combinations">
																<table>
																	<thead>
																		<tr>
																			<td>Produto</td>
																			<td>Atributos</td>
																			<td className='text-center'>Stock</td>
																			<td className='text-center'>Preço</td>
																		</tr>
																	</thead>
																	<tbody>
																		{
																		attribute_values.length > 0 ?
																			dados.current.info.combination.map((el, el_key) => {
																				let attr_name = ''
																				if(el.combination !== '') {
																					return (
																						<tr key={el_key}>
																							<td>
																								{dados.current.info.name}
																							</td>

																							<td className='div-attributes'>
																								{
																								el.combination.split(';').map((el_2, el_2_key) => {
																									if(el_2 !== '0') {
																										let aux = attribute_values.filter(v => v.id === el_2)
																										if(aux.length === 1) {
																											if(attr_name !== '')
																												attr_name += ', '
																											
																											attr_name += aux[0].name
																											return (
																												<span key={el_2_key} data-id={el_2}>
																													{
																													aux[0].name
																													}
																												</span>
																											)
																										} else
																											return ''
																									} else
																										return ''
																								})
																								}
																							</td>

																							<td>
																								<input className='form-control rounded-0 text-end' pattern="[0-9]+" data-order={el_key} data-combination={el.combination} name='stock' defaultValue={el['stock'] !== undefined && el.stock !== '' ? el.stock : dados.current.info.base.stock} onBlur={(e) => handle_change_combination(e) } />
																							</td>

																							<td>
																								<div className="input-group">
																									<input className='form-control rounded-0 text-end' data-order={el_key} data-combination={el.combination} name='price' defaultValue={el['price'] !== undefined && el.price !== '' ? el.price : dados.current.info.base.price} onBlur={(e) => handle_change_combination(e) } />
																									<div className="input-group-text rounded-0 py-2 px-3">
																										<i className="bi bi-currency-euro"></i>
																									</div>
																								</div>
																							</td>
																							<td>
																								<span 
																									className="btn btn-icon btn-active-color-primary me-1 rounded-0 border-0 bg-white border shadow"
																									data-kt-image-input-action="remove"
																									data-bs-dismiss="click"
																									//onClick={handleEdit}
																									data-bs-toggle="modal" 
																									data-bs-target={"#edit_combination_modal_" + el_key}
																									title="Edit"
																								>
																									<i className="bi bi-pencil"></i>
																								</span>
																								<span 
																									className="btn btn-icon btn-active-color-primary rounded-0 border-0 bg-white border shadow"
																									data-kt-image-input-action="remove"
																									data-bs-toggle="tooltip"
																									data-bs-dismiss="click"
																									title="Remove"
																									onClick={() => remove_combination(el.combination)}
																								>
																									<i className="bi bi-x-lg"></i>
																								</span>

																								<div className="modal modal-combination bg-light fade" tabIndex="-1" id={"edit_combination_modal_" + el_key}>
																									<div className="modal-dialog modal-dialog-centered">
																										<div className="modal-content">
																											<div className="modal-header">
																												<h5 className="modal-title">{dados.current.info.name} - {attr_name}</h5>
																												<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
																													<i className="bi bi-x-lg"></i>
																												</div>
																											</div>

																											<div className="modal-body">
																												<div className="row mb-3 d-none">
																													<div className="col-6">
																														<label className="col-form-label fw-bold fs-6">{language[lang].field_stock}</label>
																														<input className='form-control' data-order={el_key} data-combination={el.combination} name='stock' defaultValue={el['stock'] !== undefined && el.stock !== '' ? el.stock : dados.current.info.base.stock} placeholder={language[lang].field_stock_placeholder} onBlur={(e) => handle_change_combination(e) } />
																													</div>
																													<div className="col-6">
																														<label className="col-form-label fw-bold fs-6">{language[lang].field_price}</label>
																														<input className='form-control' data-order={el_key} data-combination={el.combination} name='price' defaultValue={el['price'] !== undefined && el.price !== '' ? el.price : dados.current.info.base.price} placeholder={language[lang].field_price_placeholder} onBlur={(e) => handle_change_combination(e) } />
																													</div>
																												</div>

																												<div className="row mb-3">
																													<div className="col-12">
																														{
																														dados.current.content[0]['media']['image'].map((el_media, k_media) => {
																															return (
																																<div key={k_media} className={'div-image float-left me-2'} style={{ backgroundImage:`url(${el_media.link})`, backgroundPosition:`center center`, backgroundSize:`cover`  }} onClick={() => set_combination_image(el_key, el_media.link)} >
																																	<span className={"btn btn-icon btn-active-color-primary float-right rounded-0 border-0 bg-white border shadow" + (el['image'] !== undefined && el['image'] === el_media.link ? '' : ' d-none')} >
																																		<i className="bi bi-check"></i>
																																	</span>
																																</div>
																															)
																														}) 
																														}
																													</div>
																												</div>
																											</div>

																											<div className="modal-footer">
																												<button type="button" className="btn btn-light" data-bs-dismiss="modal">{language[lang].close}</button>
																												<button type="button" className="btn btn-primary d-none" data-bs-dismiss="modal" onClick={() => console.log('#')}>{language[lang].save}</button>
																											</div>
																										</div>
																									</div>
																								</div>
																							</td>
																						</tr>
																					)
																				} else
																					return ''
																			})
																		:
																			null
																		}
																	</tbody>
																</table>
															</div>

														</div>
													</div>

												</div>
											</div>

										</div>
									</div>

									<div className={"tab-pane show"} id={"tab_pane_shipping"} role="tabpanel">
										<div className="card">
											<div className="card-header border-0 d-flex justify-content-sm-between">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].tab_shipping}</h3>
												</div>
												<div className="card-toolbar">
													
												</div>
											</div>
				
											<div className="card-body border-top p-4">
												<div className="tab-content">

													<div className="row mb-3">
														<div className="col-6 col-lg-3">
															<label className="col-form-label fw-bold fs-6">{language[lang].field_width}</label>
															<div className="input-group">
																<input className='form-control rounded-0 text-end' name='width' defaultValue={dados.current.info['shipping'] !== undefined && dados.current.info.shipping['width'] !== '' ? dados.current.info.shipping['width'] : '0'} onBlur={(e) => handle_change_combination(e) } />
																<div className="input-group-text rounded-0 py-2 px-3">
																	cm
																</div>
															</div>
														</div>

														<div className="col-6 col-lg-3">
															<label className="col-form-label fw-bold fs-6">{language[lang].field_height}</label>
															<div className="input-group">
																<input className='form-control rounded-0 text-end' name='height' defaultValue={dados.current.info['shipping'] !== undefined && dados.current.info.shipping['height'] !== '' ? dados.current.info.shipping['height'] : '0'} onBlur={(e) => handle_change_combination(e) } />
																<div className="input-group-text rounded-0 py-2 px-3">
																	cm
																</div>
															</div>
														</div>

														<div className="col-6 col-lg-3">
															<label className="col-form-label fw-bold fs-6">{language[lang].field_depth}</label>
															<div className="input-group">
																<input className='form-control rounded-0 text-end' name='depth' defaultValue={dados.current.info['shipping'] !== undefined && dados.current.info.shipping['depth'] !== '' ? dados.current.info.shipping['depth'] : '0'} onBlur={(e) => handle_change_combination(e) } />
																<div className="input-group-text rounded-0 py-2 px-3">
																	cm
																</div>
															</div>
														</div>

														<div className="col-6 col-lg-3">
															<label className="col-form-label fw-bold fs-6">{language[lang].field_weight}</label>
															<div className="input-group">
																<input className='form-control rounded-0 text-end' name='weight' defaultValue={dados.current.info['shipping'] !== undefined && dados.current.info.shipping['weight'] !== '' ? dados.current.info.shipping['weight'] : '0'} onBlur={(e) => handle_change_combination(e) } />
																<div className="input-group-text rounded-0 py-2 px-3">
																	kg
																</div>
															</div>
														</div>
													</div>

													<div className="row mb-3">
														<div className='col-12'>
															<label className="col-form-label fw-bold fs-6">{language[lang].field_delivery}</label>
															{
															carrier.map((element, key) => {
																return (
																	<div key={key} className="form-check">
																		<label className="form-check-label text-nowrap" htmlFor={"carrier_" + element.id}>
																			{element.text}
																		</label>
																		<input 
																			id={"carrier_" + element.id}
																			value={element.id}
																			type="checkbox" 
																			className='form-check-input rounded-0' 
																			data-id={element.id}
																			data-order={key}
																			onChange={handleSelectCarrier}
																			defaultChecked={handleCarrierCheckVerify(element.id)}
																		/>
																	</div>
																)
															})
															}
														</div>

													</div>

												</div>
											</div>
										</div>
									</div>
								</div>

							</div>

							<div className="col-md-4 mb-3 mb-xl-10">

								<div className="card mb-3">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="div_configuracao">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].page_config}</h3>
										</div>
										<div className="card-toolbar">

										</div>
									</div>
									<div id="div_configuracao" className="collapse show">
										<div className="card-body border-top p-4">
											<div className="row mb-3">
												<div className="col-12">
												<label className="col-form-label required fw-bold fs-6">{language[lang].reference}</label>
												<input type="text" name="reference" value={dados.current.info ? dados.current.info.reference : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].reference_placeholder} onChange={handle_change_info} required />
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={() => change_is_combination()}>combination</button>
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-6">
													<label className="col-form-label required fw-bold fs-6">{language[lang].field_price_base}</label>
													<input type="text" name="price" value={dados.current.info['base'] !== undefined ? dados.current.info['base']['price'] : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_price_base_placeholder} onChange={handle_change_info_base} required />
												</div>

												<div className="col-6">
													<label className="col-form-label required fw-bold fs-6">{language[lang].field_stock_base}</label>
													<input type="text" name="stock" value={dados.current.info['base'] !== undefined ? dados.current.info['base']['stock'] : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].field_stock_base_placeholder} onChange={handle_change_info_base} required />
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label required fw-bold fs-6">{language[lang].field_taxe_base}</label>

													<select className="form-select rounded-0" aria-label="Select taxe" name='taxe' defaultValue={dados.current.info['base'] !== undefined ? dados.current.info['base']['taxe'] : ''} onChange={handle_change_info_base}>
														<option value="0">{language[lang].choose_option}</option>
														{
															taxe_values.map((v, k) => {
																if (v.id === dados.current.id)
																	return ''

																if (is_parent(v.id, dados.current.id))
																	return ''

																return (
																	<option key={k} value={v.id}>{v.text}</option>
																)
															})
														}
													</select>
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label required fw-bold fs-6">{language[lang].name}</label>
													<input type="text" name="name" value={dados.current.info ? dados.current.info.name : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
												</div>
											</div>
											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label fw-bold fs-6">Slug do URL <small>(friendly url)</small></label>
													<div className="input-group input-group-sm mb-3 p-0">
														<span className="input-group-text rounded-0" id="basic-addon3">product/</span>
														<input type="text" name="slug" defaultValue={dados.current.info ? dados.current.info.slug : ''} onBlur={handle_change_info_slug} className="form-control rounded-0" id="basic-url" aria-describedby="basic-addon3" />
													</div>
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label fw-bold fs-6">Categorias</label>
													<ReactTags
														//tags={dados.current.info ? dados.current.info['category'] : []}
														className={"form-control rounded-0 mb-3 mb-lg-0"}
														suggestions={suggestions}
														delimiters={delimiters}
														handleDelete={handleTagDelete}
														handleAddition={handleTagAddition}
														handleDrag={handleTagDrag}
														handleTagClick={handleTagClick}
														inputFieldPosition="top"
														placeholder={language[lang].choose_category}
														allowAdditionFromPaste={false}
														autocomplete
													/>
													{
													dados.current.info['category'] !== undefined ?
														dados.current.info['category'].map((t, k) => {
															return (
																<div key={k} className="badge bg-secondary rounded-0 mt-1 me-1">
																	<span className='me-2'>{t.text}</span>
																	<span className='cursor-pointer' onClick={() => handleTagDelete(k)}>
																		<i className="bi bi-x"></i>
																	</span>
																</div>
															)
														})
													:
														null
													}
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div className="card mb-3">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_seo" aria-expanded="true" aria-controls="div_seo">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].seo_config}</h3>
										</div>
										<div className="card-toolbar">
											
										</div>
									</div>
									<div id="div_seo" className="collapse show">
										<div className="card-body border-top p-4">
											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_title}</label>
													<input type="text" name="title" value={dados.current.info.seo ? dados.current.info.seo.title : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_title_placeholder} onChange={handle_change_info_seo} />
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_keywords} <span className="text-muted fs-9">{language[lang].seo_keywords_small}</span></label>
													<input type="text" name="keywords" value={dados.current.info.seo ? dados.current.info.seo.keywords : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_keywords_placeholder} onChange={handle_change_info_seo} />
												</div>
											</div>

											<div className="row mb-3">
												<div className="col-12">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_description}</label>
													<textarea type="text" name="description" value={dados.current.info.seo ? dados.current.info.seo.description : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_description_placeholder} onChange={handle_change_info_seo} />
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
